/**
 * フィラーメッセージ関連のユーティリティ関数
 *
 * ChatGPTの挨拶判定の結果、フィラーを送信すべきと判断された場合
 * 本回答よりも後にフィラーが送信されないようにキューに追加された時間からの経過時間をもとに、フィラー送信の可否を判断するための関数
 * 本回答がキューに追加された後、閾値以上の時間が経過している場合にのみフィラーを送信する(前回の会話サイクル)
 * 閾値以内の場合はフィラー送信を抑制する(本回答→フィラーの順で送信されるものと判断して、フィラー送信を抑制する)
 */

/**
 * フィラー送信の閾値（ミリ秒）
 * 本回答から7.5秒以内の場合、本回答→フィラーの順で送信されるものと判断してフィラー送信を抑制する
 * 会話の1サイクルは早くて12秒程度
 */
export const FILLER_SEND_THRESHOLD_MS = 7500; // 7.5秒

/**
 * フィラー送信判定
 * キューが空で、最後のキュー更新から経過時間が閾値を超えている場合にフィラーを送信する
 *
 * @param queueArrayLength - メインキューの長さ
 * @param summaryQueueArrayLength - 要約キューの長さ
 * @param timeSinceQueueUpdate - 最後のキュー更新からの経過時間（ミリ秒）
 * @param threshold - フィラー送信の時間閾値（ミリ秒）
 * @returns フィラーを送信すべき場合は true
 */
export const shouldSendFiller = (
  queueArrayLength: number,
  summaryQueueArrayLength: number,
  timeSinceQueueUpdate: number,
  threshold: number = FILLER_SEND_THRESHOLD_MS
): boolean => {
  return (
    queueArrayLength === 0 && summaryQueueArrayLength === 0 && timeSinceQueueUpdate > threshold
  );
};
